import * as actionTypes from '../constants/constants';

const defaultStore = {
  username: '',
  password: '',
  logedIn: false,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        username: action.username,
        password: action.password,
        logedIn: true,
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        logedIn: false,
        username: action.username,
        password: action.password,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/login.js